/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Pipe, PipeTransform } from "@angular/core";
import { States } from "../models/states";

@Pipe({
  name: "stateAbrrToName"
})
export class StateAbrrToNamePipe implements PipeTransform {
  transform(value: string): string {
    return States[value as keyof typeof States];
  }
}
